<template lang="pug">
.other
	h1 Расписание
	template(v-for="(room,k) in schedule.schedule")
		h2(v-if="k==0") Большой зал
		h2(v-if="k==1") Малый зал
		.other__days
			.other__day(v-for="(day,i) in room" v-if="day.length>0")
				.other__day-name(v-if="day.length>0") {{returnDayOfWeek(i)}}
				.other__day-schedule(v-if="day.length>0")
					a.other__day-schedule-item(:href="'#'+item.id" v-for="item in day")

						.other__day-schedule-item-type(:class="'other__activity-color_'+item.id") {{item.type}}
						.other__day-schedule-item-time(:class="item.highlight?'other__day-schedule-item-time_highlighted':''") {{item.time}}
						.other__day-schedule-item-name(:class="item.highlight?'other__day-schedule-item-name_highlighted':''") {{item.name}}


	h1.other__what Что есть что
	.other__activity(v-for="activity in schedule.activities")
		a.other__activity-link(:name="activity.id")
		.other__activity-name-wrap
			.other__activity-name(:class="'other__activity-color_'+activity.id") {{activity.activityName}}
		.other__activity-left
			.other__activity-desc
				vue-markdown {{activity.activityDesc}}
		.other__activity-right
			.other__activity-photo(v-if="activity.activityPhoto" :style="'background-image:url('+activity.activityPhoto.fields.file.url+')'")
</template>
<script>
import { mapGetters } from "vuex";
import VueMarkdown from "vue-markdown";

export default {
	name: "home",
	computed: {
		...mapGetters({
			schedule: "main/otherItems",
			loading: "main/loading",
			loaded: "main/loaded"
		})
	},
	data() {
		return {};
	},
	methods: {
		returnDayOfWeek: function(i) {
			var days = [
				"Понедельник",
				"Вторник",
				"Среда",
				"Четверг",
				"Пятница",
				"Суббота",
				"Воскресенье"
			];
			return days[i];
		}
	},
	components: {
		VueMarkdown
	}
};
</script>

<style lang="stylus">
.other
	max-width 1000px
	margin 0 auto
	padding 30px 20px

	&__what
		padding-bottom 0

	&__days
		display flex
		@media screen and (max-width: 768px)
			flex-direction column

	&__activity
		&-link
			padding-top 30px
			display inline-block

			@media screen and (max-width: 1000px)
				padding-top 10px


		&-color
			&_40resnwITK2K6oC68I8MCg
				background-color #f55a5a

			&_399YgFpSq5ICDeLqdKOxa0
				background-color #87bdd2

			&_1sSKEPamzGQUwAMEce2qEQ
				background-color #ffd77c

			&_3zbipXYN4h0Ahlrdl4noIv
				background-color #59e490

			&_3XUcOoLqHuNUwB6mIkZFj
				background-color #dc7cdc

			&_2gVWiPD2TDR7K6D0W2eM3W
				background-color #ff9f5b

			&_3BpxSaiM8JwEdvGY4Bikkp
				background-color #f9d93c

			&_1sbD59yX1dYDcQ23vLmqs4
				background-color #b6bcc1

		&-name
			font-size 20px
			font-family Oswald
			color white
			border-radius 5px
			padding 0 10px
			text-transform uppercase
			display inline-block

			&-wrap
				padding-bottom 5px

		&-photo
			display inline-block
			width 100px
			height 100px
			border-radius 50%
			background-size cover
			background-position center center

			@media screen and (max-width: 1000px)
				display none

		&-left
			display inline-block
			width 700px
			box-sizing border-box
			padding-right 20px
			max-width 100%

		&-right
			width 100px
			display inline-block
			vertical-align top

		&-desc
			line-height 1.7em

	&__day
		flex 1
		&-name
			font-family Oswald
			text-transform uppercase
			font-size 20px

		&-schedule
			padding-top 10px
			padding-bottom 30px

			&-item
				display flex
				flex-direction column
				padding-right 20px
				padding-bottom 15px
				text-decoration none
				@media screen and (max-width: 468px)
					padding-right 0
					padding-left 20px



				&:last-child
					padding-bottom 0

				&-time, &-name, &-type
					display inline-block

				&-time
					font-family Oswald
					color #a29b9b
					padding-right 10px

					&_highlighted
						color #222

				&-type
					color #fff
					border-radius 3px
					padding 0 3px
					font-size 12px
					font-weight bold
					vertical-align top
					margin-top 7px
					margin-right 10px

				&-name
					color #888
					font-size 14px

					&_highlighted
						color #222
</style>